<div class="modal-container-secondary">
  <div class="modal-header">
    <h5 class="header-title">Edit Button</h5>
  </div>

  <div class="modal-body">
    <h6 class="body-title">Button</h6>
    <div class="mb-3">
      <div class="form-field">
        <label>Text:</label>
        <div class="field-input">
          <input
            class="input-wrapper"
            id="vipinfo-button-text"
            [value]="vipInfoButtonCopy.config.buttonTitle"
            [(ngModel)]="vipInfoButtonCopy.config.buttonTitle" />
        </div>
      </div>
      <div *ngIf="vipInfoButtonCopy.type === 'link'">
        <div class="form-field">
          <label>Url:</label>
          <div class="field-input">
            <input
              class="input-wrapper"
              id="vipinfo-button-text"
              [value]="vipInfoButtonCopy.config.url"
              [(ngModel)]="vipInfoButtonCopy.config.url" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="vipInfoButtonCopy.type === 'button'">
      <h6 class="body-title">Popup</h6>
      <div class="mb-3">
        <div class="form-field">
          <label>Title:</label>
          <div class="field-input">
            <input id="vipinfo-popup-title" class="input-wrapper" [(ngModel)]="vipInfoButtonCopy.config.popupTitle" />
          </div>
        </div>
        <div class="form-field d-flex align-items-center">
          <label>Content:</label>
          <div class="field-input">
            <button class="btn-action-icon" (click)="openModal()"><i id="edit" alt="edit icon"></i></button>
          </div>
        </div>
        <div class="form-field">
          <label>Close text:</label>
          <div class="field-input">
            <input
              id="vipinfo-close-button-text"
              class="input-wrapper"
              [(ngModel)]="vipInfoButtonCopy.config.closeButtonTitle" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn-sm-gray" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn-sm-green" (click)="onSave()">Save</button>
    <button type="button" class="btn-sm-red" (click)="onDelete()">Delete</button>
  </div>
</div>
